/* eslint-disable */
import Vue from "vue";
import Vuex from "vuex";
import ShardsVue from "shards-vue";
import store from "./vuex/store";
import Toasted from "vue-toasted";
import VueMoment from "vue-moment";
import VModal from "vue-js-modal";
// Styles
import "bootstrap/dist/css/bootstrap.css";
import "@/scss/shards-dashboards.scss";
import "@/assets/scss/date-range.scss";
// Core
import App from "./App.vue";
import router from "./router";

import VTooltip from "v-tooltip";

import VueQuill from "vue-quill";

// Layouts
import Default from "@/layouts/Default.vue";
import Home from "@/layouts/Home.vue";
import VueTour from "vue-tour";
import Cloudinary, {
  CldImage,
  CldTransformation,
  CldVideo,
  CldPoster
} from "cloudinary-vue";

require("./scss/vuetour.css");
Vue.use(Cloudinary, {
  configuration: {
    cloudName: "givemagic",
    components: {
      CldImage,
      CldXf: CldTransformation,
      CldVideo,
      CldPoster
    }
  }
});
Vue.use(VueTour);
Vue.use(VTooltip);
Vue.use(VueQuill);
ShardsVue.install(Vue);

Vue.component("default-layout", Default);
Vue.component("home-layout", Home);
Vue.use(Toasted);
Vue.use(Vuex);
Vue.use(VueMoment);
Vue.use(VModal, { dialog: true });
Vue.config.productionTip = false;
Vue.prototype.$eventHub = new Vue();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
